<div class="container pt-3 fade-in-left" id="centerFrame">
  <div class="d-flex align-items-center justify-content-center mb-4 pe-5">
    <a (click)="back()">
      <div class="p-2"><i class="bi bi-chevron-left align-middle"></i></div>
    </a>

    <div class="p-2 flex-grow-1 pl-2">
      <h1 class="text-dark text-center">Mis Notificaciones</h1>
    </div>

    <div class="p-2 pl-2 help" (click)="toggleHelp()">
      <i class="bi bi-info-circle"></i>
    </div>
  </div>

  <!-- Tooltip (si tu CSS lo tiene display:none, esto lo pisa igual) -->
  <div
    class="row m-3 p-3 align-items-center"
    id="tooltip-pwa"
    [style.display]="showHelp() ? 'flex' : 'none'"
  >
    <div class="col-auto">
      <i class="bi bi-info-circle" style="font-size: 1.8em;"></i>
    </div>

    <div class="col">{{ helpText() }}</div>

    <div class="col-auto" (click)="closeHelp()">
      <i class="bi bi-x-lg" style="font-size: 1.4em;"></i>
    </div>
  </div>

  @if (idPerfil === 1) {
    <div class="row-cols-12 m-2 mb-3">
      <!-- vacío como lo tenías -->
    </div>
  }

  <div class="row-cols-12 m-0 mb-0 ms-0 me-0 mt-0">
    @for (notificacion of notificaciones; track notificacion.id ?? notificacion.d_fecha) {
      <div
        class="row p-2 px-4 align-items-center notification mb-0"
        (click)="leerNotificaciones(notificacion)"
        [class.active]="!notificacion.b_visto"
      >
        <div class="col-auto"><a><i class="bi bi-calendar2-check"></i></a></div>

        <div class="col">
          <div class="col-xl">
            <a>
              <div class="text-title-item">{{ notificacion.x_titulo }}</div>
              <div class="text-subtitle-item">{{ notificacion.x_descripcion }}</div>
            </a>
          </div>

          <div class="col-10 text-detail-item">
            {{ notificacion.d_fecha | date: 'dd/MM/yyyy - HH:mm' }}hs
          </div>
        </div>

        <div class="col-auto">
          <i class="bi bi-chevron-right align-middle"></i>
        </div>
      </div>
    }
  </div>

  @if (idPerfil === 2) { <div class="row-cols-12 m-2 mb-3 ms-0 me-0"></div> }
  @if (idPerfil === 3) { <div class="row-cols-12 m-2 mb-3"></div> }
  @if (idPerfil === 4) { <div class="row-cols-12 m-2 mb-3"></div> }
</div>
